import { atom } from 'jotai';


const translationsAtom = atom([]);
const localeAtom = atom('');
const inlineEditAtom = atom({ inlineEdit: false, context: '', translationKey: '' });

export { translationsAtom, inlineEditAtom, localeAtom };